// Types
import { FieldsOption } from '@stripe/stripe-js';

const BILLING_DETAILS_ADDRESS = {
    city: null,
    line1: null,
    line2: null,
    postal_code: null,
    state: null,
  },
  PAYMENT_ELEMENT_PROPS = {
    id: 'payment-element',
    options: {
      fields: {
        billingDetails: { address: 'never' },
      } as FieldsOption,
    },
  },
  REDIRECT_REQUIRED = 'if_required';

export { BILLING_DETAILS_ADDRESS, PAYMENT_ELEMENT_PROPS, REDIRECT_REQUIRED };
